import About from "../component/about";
import { Award } from '../component/award';
import Contact from "../component/contact";
import Education from "../component/education";
import { Fact } from "../component/fact";
import Footer from "../component/footer";
import { Home } from "../component/home";
import Offer from "../component/offer";
import Portfolio from "../component/porfolio";
import Two from "../component/two";
import VideoShow from "../component/videoShow";

function PersonalPage (){
    return (
        <>
          <Home />
          <div className="separator w-75"></div>
          <Two />
          <div className="separator w-75"></div>
          <About />
          <div className="separator w-75"></div>
          <Portfolio />
          <div className="separator w-75"></div>
          <Fact />
          <div className="separator w-75"></div>
          <Award /> 
          {/* <div className="separator w-75"></div> */}
           {/* <Experience /> */}
          <div className="separator w-75"></div>
          <Education />
          <div className="separator w-75"></div>
          <Offer />
          <div className="separator w-75"></div>
          <VideoShow />
          <div className="separator w-75"></div>
          <Contact />
          <div className="separator w-75"></div>
          <Footer />
        </>
    )
}

export default PersonalPage;